import { takeLatest, fork } from 'redux-saga/effects';

import { DEPENDENT_FORM_PROGRESS_TYPES } from '../progress.actions';
import { deleteDocumentWatcher } from './delete-document-saga';
import { handleBack } from './back-navigation-saga';
import { handleNext } from './next-navigation-saga';
import { validateDependentFormProgress } from './validate-steps-saga';

export default function* progressRootSaga() {
  yield takeLatest(
    DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE,
    validateDependentFormProgress,
  );
  yield takeLatest(DEPENDENT_FORM_PROGRESS_TYPES.GO_BACK, handleBack);
  yield takeLatest(DEPENDENT_FORM_PROGRESS_TYPES.GO_NEXT, handleNext);
  yield fork(deleteDocumentWatcher);
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/index.js